/**
 * Photo-app style pinch-zoom helpers.
 * Content under the pinch midpoint stays fixed via scroll compensation.
 */

export const PINCH_ZOOM_MIN = 0.5;
export const PINCH_ZOOM_MAX = 3;

export function clampZoom(v: number, min = PINCH_ZOOM_MIN, max = PINCH_ZOOM_MAX): number {
  return Math.max(min, Math.min(max, v));
}

export function pinchMidpoint(a: Touch, b: Touch): { x: number; y: number } {
  return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 };
}

export function pinchDistance(a: Touch, b: Touch): number {
  return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
}

/**
 * Keep the content point under (clientX, clientY) stable when scale changes.
 * Assumes layout size scales linearly with `zoom` (CSS zoom / pdf.js renderScale).
 */
export function compensateScrollForZoom(
  el: HTMLElement,
  clientX: number,
  clientY: number,
  fromZoom: number,
  toZoom: number
): void {
  if (fromZoom <= 0 || toZoom <= 0 || Math.abs(fromZoom - toZoom) < 1e-6) return;
  const rect = el.getBoundingClientRect();
  const vx = clientX - rect.left;
  const vy = clientY - rect.top;
  const contentX = (el.scrollLeft + vx) / fromZoom;
  const contentY = (el.scrollTop + vy) / fromZoom;
  el.scrollLeft = contentX * toZoom - vx;
  el.scrollTop = contentY * toZoom - vy;
}

/** Anchor zoom change to viewport center (toolbar +/- / reset). */
export function zoomAtViewportCenter(
  el: HTMLElement | null,
  fromZoom: number,
  toZoom: number
): void {
  if (!el) return;
  const rect = el.getBoundingClientRect();
  compensateScrollForZoom(
    el,
    rect.left + rect.width / 2,
    rect.top + rect.height / 2,
    fromZoom,
    toZoom
  );
}

export function getCanvasScroll(): HTMLElement | null {
  return document.querySelector(".canvas-scroll") as HTMLElement | null;
}
